export default "__VITE_ASSET__CQHIezJ9__"